import request from '@/utils/http';
// 获取面板数据
export const getOrderBoard = (data) => {
    return request({
        url: `/api-srm-web/order/ltms/getOrderBoard`,
        method: 'post',
        data
    });
};

// 获取面板控制参数
export const controlParams = (data) => {
    return request({
        url: `/api-mdm/controlParams`,
        method: 'get',
        params: data
    });
};
